import {getMaxLength, getTplOptions} from './helper';
import {intelSizeOptions, btbIndustry, normalIndustry} from './constants';

// 重复的公共配置项前置
const sizeControlParams = {
    linkInfo: {
        label: '查看帮助',
        icon: 'share',
        show: false,
        url: 'https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/MUyZ7Y-BGz/VA_1DZ0wnN/83014101cb974d'
    },
    typeOptions: [
        {
            value: 'choose',
            label: '选择尺寸'
        }, {
            value: 'custom',
            label: '自定义尺寸'
        }
    ],
    options: intelSizeOptions
};

const designSizeControlParams = {
    linkInfo: {
        label: '查看帮助',
        icon: 'share',
        show: false,
        url: 'https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/MUyZ7Y-BGz/VA_1DZ0wnN/83014101cb974d'
    },
    typeOptions: [
        {
            value: 'choose',
            label: '选择尺寸'
        }, {
            value: 'custom',
            label: '自定义尺寸'
        }
    ],
    indestryBaseSizeMap: {
        ...btbIndustry.reduce((acc, item) => {
            acc[item] = '3:2';
            return acc;
        }, {}),
        ...normalIndustry.reduce((acc, item) => {
            acc[item] = '16:9';
            return acc;
        }, {})
    },
    options: function (e) {
        return getTplOptions(e);
    }
};

// 尺寸的规则
const sizeControlRules = [
    {
        required: true,
        validator(rule, value) {
            const {type, value: val} = value || {};
            if (type && type === 'custom' && (!val?.customWidth || !val?.customHeight)) {
                return Promise.reject('请输入自定义尺寸');
            }
            return Promise.resolve();
          }
    }
];

// 配置颜色列表
const presetColorList = [
    '(242, 97, 73, 1)', '(242, 143, 73, 1)',
    '(242, 190, 73, 1)', '(50, 166, 131, 1)',
    '(74, 161, 247, 1)', '(116, 98, 217, 1)',
    '(242, 85, 123, 1)', '(246, 222, 203, 1)',
    '(200, 227, 218, 1)', '(212, 231, 251, 1)',
    '(255, 255, 255, 1)', '(211, 217, 230, 1)',
    '(0, 0, 0, 1)'
];

export const intelFormConfig = [
    {
        name: 'composition',
        label: '模式',
        subTitle: '将按照示例设定主体和背景的相对位置',
        placeholder: '',
        visible: true,
        type: 'composition',
        params: {
            typeOptions: [
                {
                    value: 'background',
                    label: '图片生成',
                    icon: 'background'
                },
                {
                    value: 'combination',
                    label: '背景替换',
                    icon: 'element'
                }
                // {
                //     value: 'mainBody',
                //     label: '主体生成',
                //     icon: 'cube'
                // }
            ],
            options: [
                {
                    value: 'center',
                    label: '主体居中'
                }, {
                    value: 'left',
                    label: '主体居左'
                }, {
                    value: 'right',
                    label: '主体居右'
                }, {
                    value: 'top',
                    label: '主体居上'
                }, {
                    value: 'bottom',
                    label: '主体居下'
                }
            ],
            sizeInfo: {
                min: 1,
                max: 3,
                step: 1,
                labelMap: {
                    1: '主体偏小',
                    2: '标准',
                    3: '主体偏大'
                }
            }
        }
    },
    {
        name: 'mainPartCombine',
        label: '主体',
        placeholder: '',
        visible: true,
        type: 'mainPart',
        params: {
            typeOptions: [
                {
                    value: 'custom',
                    label: '主体抠图'
                }, {
                    value: 'choose',
                    label: '选择预设'
                }
            ],
            chooseMax: 6,
            options: [
                {
                    label: '写实',
                    name: '100020'
                },
                {
                    label: '二次元',
                    name: '100019'
                },
                {
                    label: '插画',
                    name: '100018'
                }
            ]
        },
        rules: [
            {
                required: true,
                validator(rule, value) {
                    const {type, value: val} = value;
                    if (type === 'generate' && !val?.prompt) {
                        return Promise.reject('请输入描述');
                    }
                    if (type === 'choose' && !val?.chooseList?.length) {
                        return Promise.reject('请选择预设图片');
                    }
                    if (type === 'custom' && !val?.uploadList?.length) {
                        return Promise.reject('请选择自定义图片');
                    }
                    return Promise.resolve();
                  }
            }
        ]
    },
    {
        name: 'mainPart',
        label: '主体',
        placeholder: '',
        visible: true,
        type: 'mainPart',
        params: {
            generatePlaceholder: `请按照“主体+特征+风格+光线+图片类型”的句式输入描述，例如:
亚洲女生，皮肤白皙，大眼睛，黑色卷发，写实风格，头像
巧克力蛋糕，暖色系，柔和的光线，摄影照片，近景特写`,
            typeOptions: [
                {
                    value: 'generate',
                    label: '生成主体'
                }, {
                    value: 'choose',
                    label: '选择预设'
                }, {
                    value: 'custom',
                    label: '主体抠图'
                }
            ],
            chooseMax: 6,
            options: [
                {
                    label: '写实',
                    name: '100020'
                },
                {
                    label: '二次元',
                    name: '100019'
                },
                {
                    label: '插画',
                    name: '100018'
                }
            ]
        },
        rules: [
            {
                required: true,
                validator(rule, value) {
                    const {type, value: val} = value;
                    if (type === 'generate' && !val?.prompt) {
                        return Promise.reject('请输入描述');
                    }
                    if (type === 'choose' && !val?.chooseList?.length) {
                        return Promise.reject('请选择预设图片');
                    }
                    if (type === 'custom' && !val?.uploadList?.length) {
                        return Promise.reject('请选择自定义图片');
                    }
                    return Promise.resolve();
                  }
            }
        ]
    },
    {
        name: 'bgControlCom',
        label: '背景',
        placeholder: '',
        visible: true,
        type: 'bgControl',
        params: {
            typeOptions: [
                {
                    value: 'bgStyle',
                    label: '风格选择'
                }, {
                    value: 'choose',
                    label: '纯色背景'
                }
            ],
            options: [
                {
                    label: '简约空间',
                    value: '简约空间',
                    preview: 'https://feed-image.baidu.com/0/pic/1964284343_1002651803_-693411219.png'
                }, {
                    label: '木质桌面',
                    value: '木质桌面',
                    preview: 'https://feed-image.baidu.com/0/pic/1325916749_-1173598645_-235671476.png'
                }, {
                    label: '大理石展台',
                    value: '大理石展台',
                    preview: 'https://feed-image.baidu.com/0/pic/-1728433154_142957138_-1875111656.png'
                }, {
                    label: '喜悦氛围',
                    value: '喜悦氛围',
                    preview: 'https://feed-image.baidu.com/0/pic/-2091497077_703710087_26536531.png'
                }, {
                    label: '未来空间',
                    value: '未来空间',
                    preview: 'https://feed-image.baidu.com/0/pic/-1949059284_-1398654404_-1368462897.png'
                }
            ],
            presetColorList: presetColorList
        },
        rules: [
            {
                required: true,
                validator(rule, value) {
                    const {type, value: val} = value;
                    if (type === 'bgStyle' && !val?.bgStyle) {
                        return Promise.reject('请选择背景风格');
                    }
                    if (type === 'choose' && !val?.colorList?.length) {
                        return Promise.reject('请选择预设颜色');
                    }
                    return Promise.resolve();
                  }
            }
        ]
    },
    {
        name: 'bgControlBg',
        label: '画面',
        placeholder: '',
        visible: false,
        type: 'bgControl',
        params: {
            generatePlaceholder: `请按照“主体+背景+清晰度+光线+景别”的句式输入描述，例如:
亚洲女孩，穿白色裙子，黑色头发，在室外花海里，高清，温和的光线下，前景为花朵
红色手提包，放在木质桌子上，超高清，温和的光线，暖色系，纵深感`,
            typeOptions: [
                {
                    value: 'generate',
                    label: '文生图'
                }, {
                    value: 'bgStyle',
                    label: '选风格'
                }, {
                    value: 'choose',
                    label: '纯色板'
                }
            ],
            options: [
                {
                    label: '几何空间',
                    value: '几何空间',
                    preview: 'https://feed-image.baidu.com/0/pic/874727314_-2055713644_-1375107086.png'
                }, {
                    label: '科技空间',
                    value: '科技空间',
                    preview: 'https://feed-image.baidu.com/0/pic/-109686961_-1703692483_-207007064.png'
                }, {
                    label: '纯色渐变',
                    value: '纯色渐变',
                    preview: 'https://feed-image.baidu.com/0/pic/-1346180842_1061537020_2047945069.png'
                }, {
                    label: '曲波律动',
                    value: '曲波律动',
                    preview: 'https://feed-image.baidu.com/0/pic/-573251015_-1131564016_-330592066.png'
                }, {
                    label: '科技炫光',
                    value: '科技炫光',
                    preview: 'https://feed-image.baidu.com/0/pic/-1561961409_178717126_-195438593.png'
                }
            ],
            presetColorList: presetColorList
        },
        rules: [
            {
                required: true,
                validator(rule, value) {
                    const {type, value: val} = value;
                    if (type === 'bgStyle' && !val?.bgStyle) {
                        return Promise.reject('请选择背景风格');
                    }
                    if (type === 'generate' && !val?.prompt) {
                        return Promise.reject('请输入描述');
                    }
                    if (type === 'choose' && !val?.colorList?.length) {
                        return Promise.reject('请选择预设颜色');
                    }
                    return Promise.resolve();
                  }
            }
        ]
    },
    {
        name: 'sizeControl',
        label: '尺寸',
        placeholder: '',
        visible: true,
        type: 'sizeControl',
        params: sizeControlParams,
        rules: sizeControlRules
    },
    {
        name: 'sizeControlBg',
        label: '尺寸',
        placeholder: '',
        visible: true,
        type: 'sizeControl',
        params: sizeControlParams,
        rules: sizeControlRules
    }
];

export const designFormConfig = [
    {
        name: 'bgBase',
        label: '底图',
        placeholder: '',
        visible: true,
        type: 'bgBase',
        params: {
            typeOptions: [
                {
                    value: 'quickUse',
                    label: '快速带入'
                },
                {
                    value: 'upload',
                    label: '上传图片'
                }
            ]
        },
        rules: [
            {
                required: true,
                validator(rule, value) {
                    const {type, value: val} = value;
                    if (type === 'quickUse' && val?.bringUrlList.length) {
                        return Promise.resolve();
                    }
                    if (type === 'upload' && val?.uploadUrl.length) {
                        return Promise.resolve();
                    }
                    return Promise.reject('请输入底图');
                  }
            }
        ]
    },
    {
        name: 'industry',
        label: '行业',
        placeholder: '',
        visible: true,
        type: 'selectControl',
        params: {
            options: [{
                value: '',
                label: '全部行业'
            }, {
                value: '5',
                label: '教育行业'
            }, {
                value: '13',
                label: '交通出行'
            }, {
                value: '9',
                label: '商品交易'
            }, {
                value: '14,28,31,20',
                label: 'B2B行业'
            }]
        }
    },
    {
        name: 'sizeControl',
        label: '尺寸',
        placeholder: '',
        visible: true,
        type: 'sizeControl',
        params: {
            showType: false,
            ...designSizeControlParams
        },
        rules: sizeControlRules
    },
    {
        name: 'templateDesign',
        label: '模板',
        placeholder: '',
        visible: true,
        type: 'templateDesign',
        params: {
            showSwitch: true,
            typeOptions: [
                {
                    value: 'intelligent',
                    label: '智能设计'
                }, {
                    value: 'choose',
                    label: '选择模板'
                }
            ],
            colorOptions: [
                {
                    value: '',
                    label: '全部'
                }, {
                    value: '红色',
                    label: '红色'
                }, {
                    value: '黄色',
                    label: '黄色'
                }, {
                    value: '橙色',
                    label: '橙色'
                }, {
                    value: '绿色',
                    label: '绿色'
                }, {
                    value: '蓝色',
                    label: '蓝色'
                }
            ],
            ratioOptions: function (e) {
                return getTplOptions(e);
            },
            chooseMax: 6
        },
        rules: [
            {
                required: true,
                validator(rule, value) {
                    const {type, value: val, switch: switchChecked} = value;
                    if (switchChecked && type === 'choose' && !val?.chooseList?.length) {
                        return Promise.reject('请选择模板');
                    }
                    return Promise.resolve();
                  }
            }
        ]
    },
    {
        name: 'writing',
        label: '文案',
        placeholder: '',
        visible: true,
        type: 'titleControl',
        params: {
            showSwitch: true
        }
    },
    {
        name: 'mainText',
        label: '主标题',
        placeholder: '请输入',
        visible: false,
        type: 'textInput',
        params: {
            strict: true,
            maxlength: function (e) {
                return getMaxLength(e);
            },
            titleSize: 'small',
            depends: {
                watch: 'industry',
                property: 'value'
            },
            sugList: {
                5: [
                    [
                        '零基础英语学习',
                        '奇妙识字教育课'
                    ],
                    [
                        '零基础学识字',
                        '零基础全新起点'
                    ],
                    [
                        '英语启蒙班',
                        '零基础学识字'
                    ],
                    [
                        '雅思寒假班开课啦',
                        '英语启蒙学习课程'
                    ],
                    [
                        '雅思寒假班报名中',
                        '打造学习的成功之路'
                    ],
                    [
                        '开启冲刺模式',
                        '精彩讲座开启'
                    ],
                    [
                        '创意大赛报名',
                        '社交技巧讲座预告'
                    ],
                    [
                        '亲子互动',
                        '轻松掌握数学'
                    ],
                    [
                        '个性化学习'
                    ]
                ]
            }
        }
    },
    {
        name: 'descText',
        label: '副标题',
        placeholder: '请输入',
        visible: false,
        type: 'textInput',
        params: {
            strict: true,
            maxlength: function (e) {
                return getMaxLength(e);
            },
            titleSize: 'small',
            depends: {
                watch: 'industry',
                property: 'value'
            },
            sugList: {
                5: [
                    [
                        '学习入门训练',
                        '基础概念解析课程'
                    ],
                    [
                        '幼升小轻松衔接',
                        '冲刺新学期'
                    ],
                    [
                        '助您迎接新学期挑战',
                        '为新学期冲刺加油'
                    ],
                    [
                        '寒假蓄能',
                        '掌握前沿知识'
                    ],
                    [
                        '火热进行中',
                        '提升社交能力'
                    ],
                    [
                        '与孩子一同探索创意',
                        '提高学习成绩'
                    ],
                    [
                        '助你成为学霸'
                    ]
                ]
            }
        }
    },
    {
        name: 'buttonText',
        label: '按钮文案',
        placeholder: '请输入',
        visible: false,
        needClear: false,
        type: 'textInput',
        params: {
            strict: true,
            maxlength: function (e) {
                return getMaxLength(e);
            },
            titleSize: 'small'
        }
    },
    // {
    //     name: 'brandText',
    //     label: '品牌名',
    //     placeholder: '请输入',
    //     visible: false,
    //     type: 'textInput',
    //     params: {
    //         strict: true,
    //         maxlength: 12,
    //         titleSize: 'small'
    //     }
    // },
    {
        name: 'otherText',
        label: '其他文案',
        placeholder: '请输入',
        visible: false,
        type: 'textInput',
        params: {
            strict: true,
            maxlength: function (e) {
                return getMaxLength(e);
            },
            titleSize: 'small'
        }
    },
    {
        name: 'businessPointB2B',
        label: '业务点',
        layerName: '主标题',
        placeholder: '请输入投放推广的产品，例：包子机',
        tip: '业务点指客户希望在百度投放推广的产品，如包子机、挖掘机等。',
        visible: false,
        type: 'autoComplete',
        params: {
            strict: true,
            maxlength: 20,
            showRequired: true,
            titleSize: 'small',
            model: 'imageCreate',
            method: 'getTradesB2B'
        },
        rules: [
            {
                required: true,
                message: '请输入业务点',
                transform(value) {
                    return value.value;
                }
            }
        ]
    },
    {
        name: 'sellingPointFirst',
        label: '卖点1',
        placeholder: '请输入',
        visible: false,
        type: 'textInputCustom',
        params: {
            strict: true,
            maxlength: 5,
            showRequired: true,
            titleSize: 'small',
            index: 0,
            model: 'imageCreate',
            method: 'querySellingPoints'
        },
        rules: [
            {
                required: true,
                message: '请输入卖点1',
                transform(value) {
                    return value.value;
                }
            }
        ]
    },
    {
        name: 'sellingPointSecond',
        label: '卖点2',
        placeholder: '请输入',
        visible: false,
        type: 'textInputCustom',
        params: {
            strict: true,
            maxlength: 5,
            showRequired: true,
            titleSize: 'small',
            index: 1,
            model: 'imageCreate',
            method: 'querySellingPoints'
        },
        rules: [
            {
                required: true,
                message: '请输入卖点2',
                transform(value) {
                    return value.value;
                }
            }
        ]
    },
    {
        name: 'sellingPointThird',
        label: '卖点3',
        placeholder: '请输入',
        visible: false,
        type: 'textInputCustom',
        params: {
            strict: true,
            maxlength: 5,
            showRequired: true,
            titleSize: 'small',
            index: 2,
            model: 'imageCreate',
            method: 'querySellingPoints'
        },
        rules: [
            {
                required: true,
                message: '请输入卖点3',
                transform(value) {
                    return value.value;
                }
            }
        ]
    },
    {
        name: 'manufacturerName',
        label: '厂商名称',
        layerName: '副标题',
        placeholder: '请输入',
        visible: false,
        needClear: true,
        type: 'textInput',
        params: {
            strict: true,
            maxlength: 12,
            titleSize: 'small'
        }
    }
];
